import { Outlet } from 'react-router';

export const PartnerLayout = () => <Outlet />;
